export default __webpack_public_path__ + "static/media/Vambraces of the Assailant.dddfa1bf.jpg";